Vue.prototype.$getInitials = function (text) {
    let returnText = "",
        arrayText = text.split(' ');

    if (arrayText.length > 1) {
        for (i = 0; i < 2; i++) {
            //Siempre toma Dos nombres
            subText = arrayText[i].substring(0, 1);
            returnText += subText.toUpperCase();
        }
        return returnText ? returnText : '-';
    }
    // subText = arrayText.substring(0, 1);
    returnText = arrayText[0].substring(0, 1);
    return returnText.toUpperCase();
}

Vue.prototype.$getEnvBaseUrl = function () {
    return process.env.VUE_APP_BASE_URL;
}

Vue.prototype.$getEnvBaseUrlBack = function () {
    return process.env.BASE_URL_API_BACK;
}

Vue.prototype.$getEnvSsoUrl = function () {
    return process.env.SSO_URL;
}

Vue.prototype.$validPermission = function (permission) {
    return (JSON.parse(localStorage.getItem('permission')).indexOf(permission) !== -1);
}

Vue.prototype.$getEnvOAuthProvidersRedirect = function () {

    let providers = [];
    if (process.env.VUE_APP_SOCIALITE_GOOGLE_REDIRECT) {
        providers.push({
            name: 'Google',
            provider: 'google',
            redirectTo: process.env.VUE_APP_SOCIALITE_GOOGLE_REDIRECT,
        });
    }

    if (process.env.VUE_APP_SOCIALITE_AZURE_REDIRECT) {
        providers.push({
            name: 'Microsoft',
            provider: 'azure',
            redirectTo: process.env.VUE_APP_SOCIALITE_AZURE_REDIRECT,
        });
    }

    return providers;
}
